import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";
import PhoneNumber from "../../components/form/components/Countrycode";
import { Button } from "../../components/button/Button";
import { Input } from "../../components/input/Input";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import Base64 from "../../utils/base64";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";
import { ForgetPasswordSelect } from "./ForgetPasswordSelect";
import { ForgetOtp } from "./ForgetOtp";
import { VerifyForget } from "./VerifyForget";

export const ForgetPassword = () => {
  const [userData, setUserData] = useState({});
  const [forgetData, setForgetData] = useState({});
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  const [loading, setLoading] = useState(false);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleForget();
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setUserData({ ...userData, [name]: value });
  };
  const handleForget = async () => {
    if (userData && userData.username) {
      const payload = {
        userName: userData.username,
      };
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/fetch-user`,
          payload,
          config
        );
        setLoading(false);
        if (res.status === 200 && res.data) {
          setForgetData(res.data);
          setStep(2);
        }
      } catch (error) {
        setLoading(false);
        console.log("error",error)
        if(error && error.response){
        swal(
          "Oops!",
          error.response && error.response.data && error.response.data.message,
          "error"
        );
      }
      }
    } else {
      swal(
        "Oops!",
        userData && !userData.username && "Please enter a valid Username",
        "error"
      );
    }
  };
  return (
    <React.Fragment>
      {step === 1 && (
        <div style={{ marginTop: "20px" }}>
          <div className="login-card border">
            <h2 className="login-heading">Forgot Password</h2>
            <div>
              <InputGroup>
                <label>Username</label>
                <Input 
                  onChange={handleInputChange}
                  id="username"
                  type="text"
                  onKeyPress={handleKeyPress}
                  placeholder="Username"
                  name="username"
                ></Input>
              </InputGroup>

              <Button
                style={{ background: "#2A3DA3" }}
                onClick={() => {
                  handleForget();
                }}
              >
                Confirm
              </Button>
            </div>
          </div>
          <Loader isLoading={loading}></Loader>
        </div>
      )}
      {step === 2 && (
        <ForgetPasswordSelect
          data={forgetData}
          stepState={(time) => setStep(time)}
          selectedType={(type) => setSelectedType(type)}
        />
      )}
      {step === 3 && (
        <ForgetOtp
          data={forgetData}
          selectedType={selectedType}
          stepState={(time) => setStep(time)}
          otpState={(otp) => setOtp(otp)}
        />
      )}
      {step === 4 && (
        <VerifyForget otp={otp && otp} stepState={(time) => setStep(time)} />
      )}
    </React.Fragment>
  );
};
